import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5eddeaab")

_pushScopeId("data-v-5eddeaab")
const _hoisted_1 = { class: "card-body preview-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  ref: "knotContent",
  class: "col-md-3 post-content knot-padding bg-black flex-container flex-column"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["card no-margin no-border", {loading: _ctx.loading}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", null, [
            _createVNode("iframe", {
              id: "ytplayer",
              width: "100%",
              height: "200",
              src: `https://www.youtube.com/embed/${_ctx.knot.youtube_url}?autoplay=1&controls=0&rel=0&fs=0`,
              title: "YouTube video player",
              frameborder: "0",
              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
              allowfullscreen: ""
            }, null, 8, ["src"])
          ])
        ], 512)
      ])
    ])
  ], 2))
})